<template>
	<div class="pay-situation-dowanload-container">
		<div class="content">
			<div class="card-wrapper" v-for="(item, index) in list" :key="index">
				<mobile-card :show-title="false" :show-footer="true">
					<template slot="content">
						<div class="flex-form-info">
							<span>{{ pageText.name }}</span>
							<span>{{ item.itemName }}</span>
						</div>

						<div class="flex-form-info">
							<span>{{ pageText.money }}</span>
							<span class="money-item">{{ item.payMoney | formatMoney }}</span>
						</div>

						<div class="flex-form-info">
							<span>{{ pageText.date }}</span>
							<span>{{ item.payTime }}</span>
						</div>

						<div class="flex-form-info">
							<span>{{ pageText.code }}</span>
							<span>{{ item.ticketNum }}</span>
						</div>
					</template>

					<template slot="footer">
						<div class="flex-form-footer">
							<div class="flex-form-btn" @click="download(item)">
								<van-icon name="down" />
								<span>{{ pageText.download }}</span>
							</div>
						</div>
					</template>
				</mobile-card>
			</div>
		</div>

		<div class="footer">
			<div class="footer-bar">
				<van-button color="#005423" block @click="onBack">{{ pageText.pre_page }}</van-button>
			</div>
		</div>
	</div>
</template>

<script>
import log from 'utils/log'
// import {getState} from "utils/state";
import storage from 'good-storage'
import MobileCard from 'components/mobile-card/index'
import apiPaySituation from 'api/pay-situation'
import utils from '@/utils/util'
import { encodeAES } from '@/utils/AESUtil.js'

export default {
	components: { MobileCard },

	data() {
		return {
			payItem: {},
			list: [],
			pageText: {
				name: this.$t('pay_situation.download.name'),
				money: this.$t('pay_situation.download.money'),
				date: this.$t('pay_situation.download.date'),
				code: this.$t('pay_situation.download.code'),
				download: this.$t('pay_situation.download.download'),
				pre_page: this.$t('pay_situation.pre_page')
			}
		}
	},

	activated() {
		this.getPayItem()
	},

	methods: {
		getPayItem() {
			let payItem = storage.session.get('pay-item')
			this.payItem = payItem
			let param = {
				arrearId: payItem.arrearId,
				orderNo: payItem.orderNo
			}
			apiPaySituation.ticket(param).then(res => {
				this.list = res.data || []
			})
		},

		download(item) {
			let token = encodeAES('ticketNum=' + item.ticketNum + '&ticketCode=' + item.ticketCode)
			console.log('----------下载票据,---', token)
			apiPaySituation.download({ getParam: { token: token } }).then(res => {
				utils.downLoad(res)
			})
		},

		onBack() {
			this.$router.back()
		}
	}
}
</script>

<style lang="scss" scoped></style>
